import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {Text} from '@wix/wix-ui-tpa/cssVars'
import {useExperiments, useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {useWidgetState} from '../../hooks/state-provider'
import {isButtonLayout} from '../../selectors/single-settings'
import {ButtonLayoutEmptyState} from './button-layout-empty-state'
import s from './empty-state.scss'
import {classes} from './empty-state.st.css'

export const EmptyState = () => {
  const {t} = useTranslation()
  const {experiments} = useExperiments()
  const buttonLayoutEmptyStateEnabled = experiments.enabled(ExperimentNames.ButtonLayoutEmptyState)

  const buttonLayout = useWidgetState(state => isButtonLayout(state.component))

  if (buttonLayout && buttonLayoutEmptyStateEnabled) {
    return <ButtonLayoutEmptyState />
  }

  return (
    <div className={s.emptyState}>
      <h2>
        <Text className={classes.font}>{t('widgetEmptyStateNotification')}</Text>
      </h2>
    </div>
  )
}
